extractKey = (data, key, def) ->
  if data[key]? then data[key].value else def

extractInt = (data, key, def) ->
  if data[key]? then parseInt(data[key].value, 10) else def

processScormPlayerData = (data) ->
  score = ->
    # Default score if no score is reported by the SCORM package
    score    = 0
    minScore = extractInt(data, "cmi.core.score.min", 0)
    maxScore = extractInt(data, "cmi.core.score.max", 100)
    score    = extractInt(data, "cmi.core.score.raw", null)
    # If no score passed by the SCORM package by the lesson is considered completed
    score    ?= 100 if success()
    score

  duration = ->
    extractKey(data, "cmi.core.session_time", null)

  incomplete = ->
    data["cmi.core.lesson_status"]?.value is "incomplete"

  success = ->
    data["cmi.core.lesson_status"]?.value in [ "passed", "completed" ]

  interactions = ->
    interactions = []
    try
      found        = true
      i            = 0
      keys         = Object.keys(data)
      key          = "cmi.interactions.0."
      object_keys  = keys.filter (k) -> k.indexOf(key) is 0
      found        = object_keys.length > 0

      if found
        for k in object_keys
          values = data[k].value
          values = [ values ] unless _.isArray(values)
          for value, i in values
            interactions[i] ?= {}
            interactions[i][k.replace(key, "")] = decodeURIComponent(value)
    catch ex
      console.error("Error while parsing SCORM interactions", ex)

    interactions

  all = ->
    _.extend data,
      interactions: interactions()
      score: score()
      duration: duration()
      success: success()
      incomplete: incomplete()

  { all, interactions, success, duration, score }

module.exports = { processScormPlayerData }
